import { ThemeEnum } from '@/shared/types/common.types';
import { getReseller } from '@/shared/utils/reseller/reseller';
import type { TModernTheme } from '@modern/theme/modern-theme.types';
import type { TModernThemeMode } from '@modern/theme/theme-mode/theme-mode.types';
import {
  toThemeReferences,
  toThemeValues,
} from '@modern/theme/theme-variables/theme-variables';
import type { TThemeTokens } from '@modern/theme/theme-variables/theme-variables.types';
import { metricsBaseTheme } from '@modern/theme/themes/base/metrics-base-theme';
import { MODERN_SHADOWS } from '@modern/theme/themes/base/shadow-base-theme';
import { typographyBaseTheme } from '@modern/theme/themes/base/typography-base-theme';
import { getModernPalettes } from '@modern/theme/themes/colors/palettes';

const palettes = getModernPalettes(getReseller());

export const MODERN_THEME_TOKENS: Readonly<
  Record<TModernThemeMode, TThemeTokens>
> = {
  [ThemeEnum.DARK]: {
    color: palettes[ThemeEnum.DARK],
    shadow: MODERN_SHADOWS[ThemeEnum.DARK],
  },
  [ThemeEnum.LIGHT]: {
    color: palettes[ThemeEnum.LIGHT],
    shadow: MODERN_SHADOWS[ThemeEnum.LIGHT],
  },
};

export const MODERN_THEME_VALUES: Readonly<
  Record<TModernThemeMode, ReadonlyMap<string, string>>
> = {
  [ThemeEnum.DARK]: toThemeValues(MODERN_THEME_TOKENS[ThemeEnum.DARK]),
  [ThemeEnum.LIGHT]: toThemeValues(MODERN_THEME_TOKENS[ThemeEnum.LIGHT]),
};

const references = toThemeReferences(MODERN_THEME_TOKENS[ThemeEnum.DARK]);

export const modernTheme: TModernTheme = {
  color: references.color,
  font: typographyBaseTheme,
  metrics: metricsBaseTheme,
  shadow: references.shadow,
};
